import actions from './actions.js';
import mutations from './mutations.js';
import state from './state.js';
import persist from './persist.js';

import StateMachine from '@rankers/lib/state_machine';

export default new StateMachine({
    name: 'Nav',
    actions,
    mutations,
    state,
    persist,
    persistentStorageKey: 'RANKERS_ONLINE_APP_NAV__STORE',
    persistentStore: window.localStorage,
});